import { defineMessages } from 'react-intl';

export const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	workflowDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.cardTitle',
		defaultMessage: 'Update request type',
		description: 'Card title when updating the workflow for an existing JSM request type',
	},
	workflowDescription: {
		id: 'conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.workflowDescription',
		defaultMessage: 'Update work type to <bold>"{workTypeName}"</bold>',
		description:
			'Description shown in the request type workflow update card. {workTypeName} is the new work type name. <bold> wraps the work type name in bold.',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.confirmButton',
		defaultMessage: 'Update',
		description: 'Label for the confirm button when updating a JSM request type workflow',
	},
	expandBodyContent: {
		id: 'conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.expandBodyContent',
		defaultMessage: 'Show more',
		description:
			'Button label to expand the card content area when text exceeds the visible height',
	},
	collapseBodyContent: {
		id: 'conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.collapseBodyContent',
		defaultMessage: 'Show less',
		description:
			'Button label to collapse the card content area after it was expanded for long text',
	},
	successPill: {
		id: 'conversation-assistant-message-actions.controllers.jsm-update-request-type-workflow-action.successPill',
		defaultMessage: `You've updated "{requestTypeName}"`,
		description:
			'Pill message shown after request type workflow update succeeds. {requestTypeName} is the request type name.',
	},
});
